import styled, { css } from 'styled-components';
export const Main = styled.div `
  z-index: 100;
  position: absolute;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.COLORS) === null || _a === void 0 ? void 0 : _a.BORDERS; }};
  .emoji-mart-scroll {
    height: 200px;
  }
  button {
    outline: none;
  }
  .emoji-mart-dark .emoji-mart-search input::placeholder {
    color: #919191;
  }
  .emoji-mart {
    border: none;
    border-radius: 8px;
    display: block;
    .emoji-mart-bar {
      .emoji-mart-anchors {
        .emoji-mart-anchor {
          cursor: pointer;
          &.emoji-mart-anchor-selected svg {
            color: inherit;
          }
        }
      }
    }
    .emoji-mart-search input {
      font-size: 14px;
      line-height: normal;
      letter-spacing: 0.5px;
      appearance: none;
    }
    .emoji-mart-scroll {
      height: 200px;
      .emoji-mart-category {
        font-size: 14px;
        .emoji-mart-category-label span {
          padding: 6px 6px 4px 6px;
        }
        &:not(.emoji-mart-no-results) {
          .emoji-mart-emoji {
            cursor: pointer;
            span {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
`;
export const Root = styled.div `
  ${({ $floating }) => $floating
    ? css `
          position: relative;
          height: 0;
          width: 0;
        `
    : css `
          ${Main} {
            position: initial;
          }
        `}
`;
//# sourceMappingURL=data:application/json;base64,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